<template>
  <view-container
    class="view-kajabi"
    header
    title="Kajabi"
    subtitle="Integre sua área de membros da plataforma Kajabi à Blitzpay."
    :breadcrumbs="breadcrumbs"
  >
    <table-header
      @add="add"
      @dispatch="dispatch"
      @searching="searching"
      :search="false"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-9"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <template v-else>
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="integrationList"
          new-design
        >
          <template #default="{ item }">
            <div class="crop">
              <span>
                {{ item.product ? item.product.name : "-" }}
              </span>
            </div>
            <!-- <div class="crop">
              <span>
                {{ item.offer ? item.offer.name : "Oferta Principal" }}
              </span>
            </div> -->
            <div class="crop">
              <span>
                {{ item.url_activation }}
              </span>
            </div>
            <div class="crop">
              <span>
                {{ item.url_deactivation }}
              </span>
            </div>
            <div>
              {{ item.offer ? `R$ ${item.offer.price}` : "Preço padrão" }}
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          new-design
          class="d-lg-none"
          :columns="['', '']"
          :data="integrationList"
        >
          <template #default="{ item }">
            <div class="responsive-table">
              <small>
                <strong>Produto:</strong>
                {{ item.product ? item.product.name : "-" }}
              </small>
              <!-- <small>
                <strong>Oferta:</strong>
                {{ item.offer ? item.offer.name : "Oferta Principal" }}
              </small> -->
              <small>
                <strong>URL Ativação:</strong>
                {{ item.url_activation }}
              </small>
              <small>
                <strong>URL Desativação:</strong>
                {{ item.url_deactivation }}
              </small>
              <small>
                <strong>Preço:</strong>
                {{ item.offer ? `R$ ${item.offer.price}` : "Preço padrão" }}
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
      </template>
      <!-- Mobile area -->
      <div class="d-flex justify-content-end my-5">
        <paginator
          v-show="integrationList.length"
          ref="paginator"
          :pagination="pagination"
          @on-update="dispatch"
        />
      </div>
    </div>

    <integration-modal
      v-model="modal"
      title="Kajabi"
      link="https://kajabi.com/"
    >
      <kajabi-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </view-container>
</template>
<script>
import KajabiModal from "@/components/tools/modals/member-area/Kajabi.vue";

import IntegrationsMixin from "@/mixins/integration";

export default {
  mixins: [IntegrationsMixin],
  components: {
    KajabiModal
  },
  data() {
    return {
      integration: "kajabi",
      columns: [
        "Produto",
        // "Oferta",
        "URL Ativação",
        "URL Desativação",
        "Preço",
        ""
      ],
      actions: [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Excluir integração",
          class: "text-danger",
          icon: "fa-solid fa-trash",
          confirmation: {
            newDesign: true,
            submitButtonClass: "btn-danger",
            enable: true,
            text:
              "Deseja mesmo excluir esta integração? O blitzpay não enviará mais os leads para esta segmentação."
          },
          event: "delete"
        }
      ],
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Área de membros", link: "tools-member-area" },
        { title: "Kajabi" }
      ]
    };
  }
};
</script>
